const isIdInArr = (idString: string, idArr: string[]) => {
    return idArr.includes(idString)
}

export { isIdInArr }
